















import { Component, Mixins, Prop } from "vue-property-decorator";
import { RangeOfMotionTextEditableObjectMixin } from "./mixins";
import { MuscularStrengthInputKinds, MuscularStrengthValueKinds } from "../../../../domain/document";

@Component({
})
export default class RangeOfMotionMmtInput extends Mixins(
  RangeOfMotionTextEditableObjectMixin,
) {
  @Prop()
  inputKind: MuscularStrengthInputKinds;

  @Prop()
  valueKind: MuscularStrengthValueKinds;

  get isKeyboardInput(): boolean {
    return (this.inputKind === MuscularStrengthInputKinds.Keyboard) || !this.inputKind;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (!this.isKeyboardInput) { return; }
    const value = this.convertToMuscularStrengthValue(event.key);
    // 0～5以外のキーを押されたときの動作について、徳大版は空文字になるが、北大版は元の文字を保持している
    // 徳大では関節可動域は使用していないので、北大版に合わせて元の文字を保持するようにしている
    if (value === undefined) { return; }
    event.preventDefault(); // 値の変更と同時にフォーカスを移動させた場合、正しく反映できない場合があるため(Chromeでmmt→romに移動するとmmtのキー値がromに入る)
    this.$nextTick(() => {
      // IMEがONのとき、keydownのあとにもイベントが来るので、フォーカス遷移した先に入力したことになる模様
      // そのとき、オブジェクトの更新が連続して発生して、後の更新が勝って前の更新が無かったことになっているように見える
      // いったん$nextTickしてイベントが掃けた後に更新することで対策している
      this.valueSource = value;
    });
  }

  convertToMuscularStrengthValue(value: string): string {
    // 変換必要ないものは先に処理.
    switch (value) {
      case "Del":       // IE.
      case "Delete":    // chrome.
      case "Backspace": // chrome/IE.(IEだと入力中以外はブラウザの戻る操作になるのでユーザへの案内はオススメできない.)
        this.$logger.info("クリアします.(" + value + ")");
        return "";
    }
    // 変換必要なものは以下で.
    switch (this.valueKind) {
      case MuscularStrengthValueKinds.Symbol:
        return this.convertToSynbol(value);
      case MuscularStrengthValueKinds.SymbolAndNumber:
        return this.convertToSymbolAndNumber(value);
      case MuscularStrengthValueKinds.Number:
      default:
        return this.convertToNumber(value);
    }
  }

  convertToSynbol(value: string): string {
    switch (value) {
      case "0":
      case "1":
      case "2":
        return "×";
      case "3":
        return "△";
      case "4":
      case "5":
        return "○";
    }
    return undefined;
  }

  convertToSymbolAndNumber(value: string): string {
    switch (value) {
      case "0":
      case "1":
      case "2":
        return "×";
      case "3":
        return "△";
      case "4":
      case "5":
        return value;
    }
    return undefined;
  }

  convertToNumber(value: string): string {
    switch (value) {
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
        return value;
    }
    return undefined;
  }

  onClick(): void {
    if (this.isKeyboardInput) { return; }
    const nextValue = this.getNextValue(this.valueSource);
    this.valueSource = this.convertToMuscularStrengthValue(nextValue);
  }

  getNextValue(value: string): string {
    switch (value) {
      case "": return "0";
      case "0": return "1";
      case "1": return "2";
      case "2": return "3";
      case "3": return "4";
      case "4": return "5";
      case "5": return "";
      case "×": return "3";
      case "△": return "4";
      case "○": return "";
    }
    return "0";
  }

  get description(): string {
    return this.isKeyboardInput
      ? this.descriptionForKeyboardInput
      : this.descriptionForClickInput;
  }

  get descriptionForKeyboardInput(): string {
    switch (this.valueKind) {
      case MuscularStrengthValueKinds.Symbol:
        return "テンキー入力\n×：0,1,2\n△：3\n○：4,5";
      case MuscularStrengthValueKinds.SymbolAndNumber:
        return "テンキー入力\n×：0,1,2\n△：3\n4：4\n5：5";
      case MuscularStrengthValueKinds.Number:
      default:
        return "テンキー入力\n0、1、2、3、4、5";
    }
  }

  get descriptionForClickInput(): string {
    switch (this.valueKind) {
      case MuscularStrengthValueKinds.Symbol:
        return "クリックで×、△、○が切り替わります";
      case MuscularStrengthValueKinds.SymbolAndNumber:
        return "クリックで×、△、4、5が切り替わります";
      case MuscularStrengthValueKinds.Number:
      default:
        return "クリックで1、2、3、4、5が切り替わります";
    }
  }

  get isVisible(): boolean {
    return this.editingSource.isVisible;
  }
}
